<template>
  <div
    v-if="!loadding"
    class="confirm-wrap"
  >
    <div class="text-c666 font-s16 mt-24 mb-16">
      {{ TLang("填写并核对收货信息", "list") }}
    </div>
    <div class="border-ce5">
      <!-- address 订单收货地址模块 -->
      <orderAddress
        :defaultAddressId="addressId"
        :addressList="addressList"
        :loadding="!loadding"
        :editAddressItem="address"
        :newAddressNotice="newAddressNotice"
        :invalideDialog="invalideDialog"
        :epidemicDeliverInfo="epidemicDeliverInfo"
        :onSetDefaultAddress="onSetDefaultAddress"
        :onEdit="onEdit"
        :onAdd="onAdd"
        :sendGio="sendGio"
        :checkAddress="settleAccountInfo.isAllowed===1?[]:checkAddressList"
        :settleAccountInfo="settleAccountInfo"
      />
      <div class="line"></div>
      <orderHaitaoForm
        v-if="hasHaitao"
        ref="haitaoInfo"
      />
      <div
        v-if="hasHaitao"
        class="line"
      ></div>
      <!-- merchantList 中为可售商品 props buyGoodsList -->
      <merchantList
        :buyGoodsList.sync="buyGoodsList"
        :epidemicDeliverInfo="epidemicDeliverInfo"
        :handlePartsNum="modifyPartsNum"
        :choosePartsLoading="choosePartsLoading"
      />
      <!-- notSaleProductsList 不可售商品列表 props notSaleProducts -->
      <notSaleProductsList :notSaleProducts="notSaleProducts" />
    </div>
    <div
      v-if="couponInfo && couponInfo.coupon === 'Y'"
      class="coupon-wrap mt-16"
    >
      <span>
        {{
          ReplaceText(
            "QQQ",
            couponInfo.availableCouponList.length || 0,
            ReplaceText(
              "XXX",
              couponInfo.couponNum,
              TLang("couponCount", "orderConfirm")
            )
          )
        }}</span><span
        class="conponCode"
        @click="openCouponTip"
      >{{
        TLang("couponCount2", "orderConfirm")
      }}</span>
    </div>

    <div
      v-if="confrimOrderInfo && confrimOrderInfo.queryEnterPrise"
      id="enterpriseBalance"
      class="enterprise-balance-part"
    >
      <div class="enterprse-person-all">
        <div class="enterprise-title">
          {{ TLang("选择支付账户", "orderConfirm") }}
        </div>
        <div class="enterprse-person-wrapper">
          <div
            class="enterprise-personnal-item-wrapper"
            :class="{'enterprise-personnal-item-wrapper-active':selectAccountType==='enterprise'}"
            @click="changeAccountType('enterprise')"
          >
            <img
              class="enterprise-icon"
              :src="selectAccountType==='enterprise'?require('./imgs/selected_icon.png'):require('./imgs/no_selected.png')"
              alt=""
            />
            <div>
              <div class="enterprise-personnal-item-title">
                {{ interestsInfo && interestsInfo.unionAccountName? interestsInfo.unionAccountName: TLang("企业账户新", "orderConfirm") }}
              </div>
              <div class="enterprise-personnal-item-subTitle">
                <span v-if="CheckCN()">
                  <span>{{ TLang("提交订单并审核通过后", "orderConfirm") }}</span>
                  <span class="blue-style">{{ TLang("自动全额抵扣", "orderConfirm") }}</span>
                </span>
                <span v-else>
                  <span class="blue-style">{{ TLang("自动全额抵扣", "orderConfirm") }}</span>
                  <span>{{ TLang("提交订单并审核通过后", "orderConfirm") }}</span>
                </span>
              </div>
            </div>
          </div>
          <div
            class="enterprise-personnal-item-wrapper"
            :class="{'enterprise-personnal-item-wrapper-active':selectAccountType==='personnal'}"
            @click="changeAccountType('personnal')"
          >
            <img
              class="enterprise-icon"
              :src="selectAccountType==='personnal'?require('./imgs/selected_icon.png'):require('./imgs/no_selected.png')"
              alt=""
            />
            <div>
              <div class="enterprise-personnal-item-title">
                {{ interestsInfo && interestsInfo.personalAccountName?interestsInfo.personalAccountName:TLang("个人账户", "orderConfirm") }}
              </div>
              <div class="enterprise-personnal-item-subTitle">
                <span v-if="CheckCN()">
                  <span>{{ TLang("提交订单并审核通过后", "orderConfirm") }}</span>
                  <span class="orange-style">{{ TLang("需手动支付", "orderConfirm") }}</span>
                </span>
                <span v-else>
                  <span class="orange-style">{{ TLang("需手动支付", "orderConfirm") }}</span>
                  <span>{{ TLang("提交订单并审核通过后", "orderConfirm") }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <balanceList
        v-if="selectAccountType==='enterprise'"
        :interestsInfo="interestsInfo"
        :sendGio="sendGio"
        @func="getChooseData"
      />
    </div>
    <div class="order-control">
      <div class="border-ce5 mt-16">
        <div class="settle-wrap">
          <div class="settle-wrap-item">
            <span
              class="font-c666"
              style="margin-right: 10px"
            >
              {{ TLang("totalProduct1", "orderConfirm") }}
              <em class="font-s14">{{ settleAccountInfo.orderTotalNums }}</em>
              {{ TLang("totalProduct2", "orderConfirm") }}，{{
                TLang("商品总价", "list")
              }}({{ settleAccountInfo.union_name }}):
            </span>
            <span class="text-num-c111">
              {{ settleAccountInfo.orderTotalGoodsAmount }}
            </span>
          </div>
          <div class="settle-wrap-item mt-12 order-freight">
            <el-tooltip
              v-if="settleAccountInfo.orderTotalFeight > 0"
              effect="light"
              placement="bottom"
            >
              <div slot="content">
                <ul class="feight-weight-info">
                  <li
                    v-for="(item, index) in freightInfoList"
                    v-show="item.baseFreight > 0 || item.weightFreight > 0"
                    :key="`freight_${index}`"
                    :style="{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginBottom: '20px',
                    }"
                  >
                    <div :style="{ textAlign: 'left' }">
                      {{ item.showName }}&nbsp;&nbsp;
                    </div>
                    <ul>
                      <li
                        v-if="item.baseFreight > 0"
                        :style="{ marginBottom: '10px', textAlign: 'right' }"
                      >
                        {{ TLang("基础运费", "orderConfirm") }}({{
                          union_name
                        }})：{{ (item.baseFreight * union_scale).toFixed(2) }}
                      </li>
                      <li
                        v-if="item.weightFreight > 0"
                        :style="{ marginBottom: '10px', textAlign: 'right' }"
                      >
                        {{ TLang("续重运费", "orderConfirm") }}({{
                          union_name
                        }})：{{ (item.weightFreight * union_scale).toFixed(2) }}
                      </li>
                      <li
                        v-if="item.weightFreight > 0"
                        :style="{
                          background: 'rgba(153, 153, 153, .1)',
                          color: '#999999',
                          textAlign: 'right',
                          fontSize: '12px',
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                          overflow: 'hidden',
                          padding: '2px 6px',
                        }"
                      >
                        {{
                          TLang("总重量", "list") +
                            item.totalWeight +
                            TLang("超出重量", "list") +
                            parseFloat(
                              (item.totalWeight - item.freeShipping).toFixed(3)
                            ) +
                            TLang("超出部分", "list") +
                            item.noPostage * union_scale +
                            settleAccountInfo.union_name +
                            "/kg"
                        }}
                      </li>
                    </ul>
                  </li>
                </ul>
                <div
                  class="showFreightRule"
                  @click="showFreightRule"
                >
                  {{ TLang("运费收取规则", "list") }}
                </div>
              </div>
              <el-button
                :style="{ position: 'absolute', background: 'rgba(0,0,0,0)' }"
              ></el-button>
            </el-tooltip>
            <img
              v-if="settleAccountInfo.orderTotalFeight > 0"
              src="@assets/images/order/freightRule.png"
              width="16px"
            />
            <span
              id="totalFreight"
              class="font-c666"
              style="margin-right: 10px"
            >{{ TLang("运费", "orderConfirm") }}({{
              settleAccountInfo.union_name
            }}):</span>
            <span class="text-num-c111">
              {{ settleAccountInfo.orderTotalFeight }}
            </span>
            <div
              v-if="showFreightTips"
              class="tips"
            >
              {{ TLang('收货地址修改，运费发生变化', 'orderConfirm') }}
            </div>
          </div>
          <div
            v-if="settleAccountInfo.totalServiceFee > 0"
            class="settle-wrap-item mt-12"
          >
            <el-tooltip
              effect="light"
              placement="bottom-end"
              :content="tipContent"
            >
              <span
                class="line-service"
                style="margin-right: 10px"
              >
                <img src="@assets/images/order/freightRule.png" />
                {{ TLang('平台服务费','my') }}:
              </span>
            </el-tooltip>
            <span class="text-num-c111">
              {{ Number(settleAccountInfo.totalServiceFee).toFixed(2) }}
            </span>
          </div>
          <div
            v-if="activeReduceNum > 0"
            class="settle-wrap-item mt-12"
          >
            <span
              class="font-c666"
            >{{ TLang("立减", "orderConfirm") }} ({{
              settleAccountInfo.union_name
            }}):</span>
            <!-- <span class="text-num-c111">
              -{{ settleAccountInfo.reducePrice }}
            </span> -->
            <!-- 优惠金额设置膨胀比 -->
            <span class="text-num-c111">
              -{{ (activeReduceNum * union_scale).toFixed(2) }}
            </span>
          </div>
          <!-- 折上折 专享优惠 -->
          <div
            v-if="settleAccountInfo.additionalDiscountAmount"
            class="settle-wrap-item mt-12"
          >
            <span
              class="font-c666"
            >{{ TLang("专享优惠", "orderConfirm") }}({{
              settleAccountInfo.union_name
            }}):</span>
            <span class="text-num-c111">
              -{{
                (
                  (settleAccountInfo.additionalDiscountAmount || 0) *
                  union_scale
                ).toFixed(2)
              }}
            </span>
          </div>
          <div class="settle-wrap-item mt-12">
            <span class="font-c666">{{
              TLang("应付金额", "orderConfirm")
            }}</span>
            <span>
              <img
                :src="settleAccountInfo.fudou"
                alt
                class="fudou-15"
              />
              <em class="text-num-bold-red font-s20">
                {{ settleAccountInfo.orderAccountPayable }}
              </em>
            </span>
          </div>
          <div
            v-if="selectAccountId"
            class="settle-wrap-account mt-12"
          >
            {{ ReplaceText('XXX', interestsInfo && interestsInfo.unionAccountName?interestsInfo.unionAccountName:TLang('企业账户', 'orderConfirm'), TLang('审核通过后企业账户全额抵扣', 'orderConfirm')) }}
          </div>
          <div class="settle-wrap-item mt-20 clearfix">
            <div
              id="create-order"
              v-loading.fullscreen.lock="createOrderDisabled"
              class="btn-theme-w150 fr"
              :class="{
                'order-disable':
                  all_valided ||
                  settleAccountInfo.isAllowed===0 ||
                  (epidemicDeliverInfo.allowDelivery === 0 &&
                  epidemicDeliverInfo.mandatoryType === 0),
              }"
              @click="
                () => {
                  onCreateOrder();
                }
              "
            >
              {{ TLang("提交订单", "list") }}
            </div>
          </div>
          <div class="mt-12 text-right">
            <span
              class="dib mr-8 font-c999"
            >{{ TLang("收货信息", "orderConfirm") }}：{{
              settleAccountInfo.consigneeInfo
            }}</span>
            <span class="font-c999">{{ settleAccountInfo.addressInfo }}</span>
          </div>
        </div>
      </div>
    </div>
    <Dialog
      title=" "
      :visible="invalideDialog && !editAddressDialog"
      width="420px"
      close-on-click-modal
      custom-class="order-invalide-dialog"
      center
      top="50vh"
      :show-close="false"
      @open="invalideDialog = true"
      @close="invalideDialog = false"
    >
      <img :src="require('@assets/images/smallBell.png')" />
      <p class="desc part_valided">
        {{ confirmOrderTips }}
      </p>
      <div>
        <button
          class="btns close"
          @click="closeDialog"
        >
          {{ TLang("我知道了", "my") }}
        </button>
        <a
          v-if="all_valided"
          class="btns back"
          :href="backLink"
        >{{
          all_valideButton
        }}</a>
      </div>
    </Dialog>
    <Dialog
      title="信息确认"
      :visible="birthdayRemarkModal"
      width="528px"
      close-on-click-modal
      custom-class="birthday-nuoxin-dialog"
      center
      top="50vh"
      @open="birthdayRemarkModal = true"
      @close="birthdayRemarkModal = false"
    >
      <div class="content">
        <!-- <h3>信息确认</h3> -->
        <p>
          <span class="head-text">{{ TLang("生日牌内容", "list") }}</span>
          <span class="userremark">{{ userRemark || "生日快乐" }}</span>
        </p>
        <div class="nuoxin-footer">
          <div
            v-loading.fullscreen.lock="createOrderDisabled"
            class="nuoxin-confirm"
            @click="onCreateOrder"
          >
            {{ TLang("提交订单", "list") }}
          </div>
          <div
            class="nuoxin-close"
            @click="birthdayRemarkModal = false"
          >
            {{ TLang("返回修改", "list") }}
          </div>
        </div>
      </div>
    </Dialog>
    <!-- 优惠券提示 -->
    <Dialog
      title=" "
      :visible="showCouponDialog"
      width="720px"
      custom-class="couponDialog"
      close-on-click-modal
      center
      top="50vh"
      :show-close="true"
      @open="showCouponDialog = true"
      @close="showCouponDialog = false"
    >
      <CouponTip :qrcodeImg="qrcodeImg" />
    </Dialog>
    <Popups
      v-if="!union_isBilingual"
      ref="popus"
      :showCancel="isShowCancel"
      :showPopus="editAddressDialog"
      :title="addressDialog.title"
      :addressItem="addressDialog.addressItem"
      :sendGio="sendGio"
      :checkAddress="checkAddressList"
      @onConfirmEditAddressDialog="onConfirmEditAddressDialog"
      @onCancelEditAddressDialog="onCancelEditAddressDialog"
      @onNewAddressCancel="onNewAddressCancel"
    />
    <PopupsEn
      v-if="union_isBilingual"
      ref="popus"
      :showCancel="isShowCancel"
      :showPopus="editAddressDialog"
      :title="addressDialog.enTitle"
      :addressItem="addressDialog.addressItem"
      :sendGio="sendGio"
      :checkAddress="checkAddressList"
      @onConfirmEditAddressDialog="onConfirmEditAddressDialog"
      @onCancelEditAddressDialog="onCancelEditAddressDialog"
      @onNewAddressCancel="onNewAddressCancel"
    />
    <!-- 微创健康提示 -->
    <Dialog
      title=" "
      :visible="visitRefundFlag"
      width="420px"
      close-on-click-modal
      custom-class="order-invalide-dialog"
      center
      top="50vh"
      :show-close="false"
      @open="visitRefundFlag = true"
      @close="visitRefundFlag = false"
    >
      <img :src="require('@assets/images/smallBell.png')" />
      <p class="desc part_valided mpTip">
        {{ TLang("微创年度健康福利提示", "orderConfirm") }}
      </p>
      <p class="mpDesc">
        {{ TLang("wcTips1", "orderConfirm") }}
      </p>
      <div>
        <button
          class="btns mpOk"
          @click="mpOk"
        >
          {{ TLang("确定", "my") }}
        </button>
        <button
          class="btns mpClose"
          @click="mpClose"
        >
          {{ TLang("取消", "my") }}
        </button>
      </div>
    </Dialog>
    <Dialog
      :title="TLang('运费收取规则', 'list')"
      :visible.sync="showFreightRuleFlag"
      width="420"
      center
      top="40vh"
      :before-close="handleClose"
      custom-class="freightDialog"
    >
      <span>
        {{
          ReplaceText(
            "QQQ",
            5 * union_scale + "" + union_name,
            ReplaceText(
              "&&&",
              99 * union_scale + "" + union_name,
              ReplaceText(
                "XXX",
                99 * union_scale + "" + union_name,
                TLang("FreightTips", "orderConfirm")
              )
            )
          )
        }}
      </span>
    </Dialog>
    <Dialog
      :title="''"
      :visible.sync="showPartsTipFlag"
      width="420"
      center
      top="40vh"
      custom-class="partsDialog"
      :before-close="createOrderAction"
    >
      <span>
        配件不支持独立售后、不支持换货/补发，请在申请蛋糕售后退款/退货退款时选择和蛋糕一起进行
      </span>
      <div
        class="partsKnowBtn"
        @click="showPartsTipFlag = false"
      >
        知道了
      </div>
    </Dialog>
    <Dialog
      :title="''"
      :visible="!invalideDialog && showPartsNoStockFlag"
      width="420"
      center
      top="40vh"
      custom-class="partsDialog"
    >
      <span> 抱歉，您的订单中部分配件已失效或库存不足，请重新选择 </span>
      <div
        class="partsKnowBtn"
        @click="showPartsNoStockFlag = false"
      >
        知道了
      </div>
    </Dialog>
    <Dialog
      :title="''"
      :visible="submitStockNullFlag"
      width="420"
      center
      top="40vh"
      custom-class="partsDialog"
    >
      <span>
        抱歉，您的订单中部分商品/配件已失效或库存不足，已为您删除，请重新确认后下单
      </span>
      <div
        class="partsKnowBtn"
        @click="submitReload"
      >
        知道了
      </div>
    </Dialog>
    <!-- 微创健康提示 -->
    <Dialog
      title=" "
      :visible="selectEnterpriseShow"
      width="420px"
      close-on-click-modal
      custom-class="order-invalide-dialog"
      center
      top="50vh"
      :show-close="true"
      @open="selectEnterpriseShow = true"
      @close="selectEnterpriseShow = false"
    >
      <p class="desc part_valided_enterprise">
        {{ TLang("您有可用的企业账户未使用", "orderConfirm") }}
      </p>
      <div>
        <button
          class="btns enterpriseClose"
          @click="enterpriseOk"
        >
          {{ TLang("提交订单", "list") }}
        </button>
        <button
          class="btns enterpriseOk"
          @click="enterpriseClose"
        >
          {{ TLang("去使用", "orderConfirm") }}
        </button>
      </div>
    </Dialog>
    <Dialog
      :title="''"
      :visible="noChoosePayShow"
      center
      top="40vh"
      width="420px"
      close-on-click-modal
      custom-class="order-invalide-dialog"
      @open="noChoosePayShow = true"
      @close="noChoosePayShow = false"
    >
      <div class="no-choose-pay-tip">
        {{ TLang("请选择支付账户", "orderConfirm") }}
      </div>
      <div
        class="btns enterpriseOk mar-40"
        @click="noChoosePayClick"
      >
        {{ TLang("知道了", "orderConfirm") }}
      </div>
    </Dialog>
  </div>
</template>

<script>
import API_ENV from "@utils/API_ENV";
import { mapState, mapGetters, mapActions } from "vuex";
import ConfirmDialog from "@components/confirmDialog";
import Cookies from "js-cookie";
import { getQueryString, unionFlag } from "@utils/index";
import { gioClickHandle } from "@utils";
import merchantList from "./components/merchantList";
import notSaleProductsList from "./components/notSaleProductList";
import orderSettle from "./components/orderSettle";
import orderAddress from "./components/orderAddress";
import orderHaitaoForm from "./components/orderHaitaoForm";
import CouponTip from "./components/couponTip";
import Loading from "@components/SimpleLoading";
import { confirmOrder, createOrder, getQrcodeUrl } from "@fetch/order";
import { Dialog } from "element-ui";
import Popups from "./components/orderAddress/popups";
import PopupsEn from "./components/orderAddress/popupsEn";
import Toast from "@components/simpleToast";
import balanceList from './components/balanceList';
import * as addressApiV2 from '@fetch/addressV2';

export default {
  name: "OrderConfirmV2",
  components: {
    orderAddress, //地址模块
    merchantList, //可售商品模块
    notSaleProductsList, //失效商品模块
    orderSettle, // 订单支付模块
    ConfirmDialog,
    orderHaitaoForm,
    Dialog,
    Popups,
    PopupsEn,
    CouponTip,
    balanceList,
  },
  data() {
    return {
      isShowCancel: true,
      isFirstLoad: true, // 是否第一次加载
      isCallBackReload: false, // 地址添加窗口关闭后是否要触发重新加载地址
      addressId: 0, // 默认收货地址 id
      address: null, // 收货地址
      goodsList: [], // 下单商品信息
      loadding: true,
      confirmDialog: false,
      confirmOrderTips: this.TLang("orderGoodsInvalid", "orderConfirm"),
      newAddressNotice: false,
      invalideDialog: false,
      visitRefundFlag: false,
      all_valided: false,
      part_valided: false,
      backLink: "",
      editdialog: false,
      addressDialog: {
        dialogState: true, // 编辑 false 添加 true
        title: this.TLang("新增收货地址", "orderConfirm"),
        enTitle: this.TLang("新增收货地址", "orderConfirm"),
        addressItem: null,
      }, // 地址新建、编辑弹层
      editAddressDialog: false,
      isReload: false, // 关闭弹窗是否需要刷新页面
      birthdayRemarkModal: false, // 诺心生日牌确认弹框
      userRemark: "", // 生日牌内容
      editAddressItem: {},
      addressList: [],
      createOrderDisabled: false,
      showCouponDialog: false, // PC暂时不展示优惠券，只提示
      unionFlag: unionFlag(),
      qrcodeImg: require("@assets/images/MiniApps.png"),
      showFreightRuleFlag: false,
      annexBuyGoodsList: [], // 收费配件
      showPartsTipFlag: false, // 配件不单独售后提示弹窗
      showPartsNoStockFlag: false, // 配件失效提示弹窗
      submitStockNullFlag: false, // 提交订单后商品库存不足提示框
      choosePartsLoading: false, // 配件选择调取接口，加载中
      checkAddressList: [], // 工会地址限制
      showFreightTips: false, // 运费变化提示
      selectAccountId: null, // 选中账户id
      payAccountName: '', // 选中账户名称
      selectEnterpriseShow: false, // 未选企业账户抵扣提示
      jumpEnterprise: false,
      selectAccountType: '',
      noChoosePayShow: false,
    };
  },
  computed: {
    ...mapState("orderConfirm", [
      "hasHaitao",
      "createCode",
      "createOrderParameter",
      "confirmInfo"
    ]),
    ...mapState({
      buyGoodsList: (state) => state.orderConfirm.buyGoodsList,
      freightInfoList: (state) => state.orderConfirm.freightInfoList,
      annexItemStock: (state) => state.orderConfirm.annexItemStock,
      notSaleProducts: (state) => state.orderConfirm.notSaleGoodsList,
      settleAccountInfo: (state) => state.settleAccountInfo,
      energizerFreightInfo: (state) => state.energizerFreightInfo,
      interestsInfo: (state) => state.interestsInfo,
      confrimOrderInfo: state => state.confrimOrderInfo,
    }),
    ...mapGetters("orderConfirm", {
      buyGoodsList: "getBuyGoodsList", // 可购买的商品
      freightInfoList: "getFreightInfoList", // 运费
      annexItemStock: "getAnnexItemStock", // 配件库存变化
      settleAccountInfo: "getSettleAccountInfo", // 订单结算总计
      energizerFreightInfo: "getEnergizerFreightInfo", // 电子围栏运费变化
      userAddressList: "getUserAddressList",
      notSaleGoodsList: "getNotSaleGoodsList",
      epidemicDeliverInfo: "getEpidemicDeliverInfo",
      couponInfo: "getCouponInfo",
      interestsInfo: 'getInterestInfo',
      confrimOrderInfo: "getConfrimOrderInfo",
    }),
    // 立减金额
    activeReduceNum() {
      const num =
        (this.settleAccountInfo.reducePrice || 0) -
        (this.settleAccountInfo.additionalDiscountAmount || 0);
      if (num > 0) {
        return num;
      }
      return 0;
    },
    tipContent() {
      return <div style={{width:'200px', display:'flex', color:'#333'}}>
        {TLang('服务费不计入包邮或满减门槛，以上门槛基于商品实际金额计算','my')}
      </div>;
    },
  },
  watch: {
    buyGoodsList(oval, nval) {
      if (!nval) return null;
      if (oval == nval) return;
      this.loadding = false;
      Loading.hide();
      this.choosePartsLoading = false;
    },
    notSaleGoodsList: {
      handler(oldVal, newVal) {
        this.checkIsShowGoodsTip();
      },
      deep: true,
    },
    couponInfo: {
      handler(oldVal, newVal) {
        this.getQrCode();
      },
      deep: true,
    },
    annexItemStock: {
      handler(oldVal, newVal) {
        this.checkPartsStock();
      },
      deep: true,
    },
    energizerFreightInfo: {
      handler(newVal, oldVal) {
        // console.log('让我看看这里面是怎么展示的：newVal：', newVal, ' oldVal:', oldVal)
        if (newVal){
          setTimeout(() => {
            this.electronicFenceFreight(newVal);
          }, 500);
        }
      },
      deep: true,
    },
  },
  created() {
    this.isFirstLoad = true;
    this.initData();
  },
  mounted() {
    // if (this.loadding && !this.address.id) {
    //   this.editAddressDialog = !this.editAddressDialog;
    //   this.addressDialog.addressItem = this.editAddressItem;
    // }
  },
  methods: {
    ...mapActions("orderConfirm", ["getConfirmOrder", "createOrder"]),
    ...mapActions("address", [
      "addAddress",
      "editAddress",
    ]),
    /** 选中账户id*/
    getChooseData(selectId, name){
      this.selectAccountId = selectId;
      this.payAccountName = name;
    },
    changeAccountType(type){
      let nowType = type;
      if (this.selectAccountType === type){
        nowType = '';
      }
      // 点击个人账户
      if (type === 'personnal') {
        this.selectAccountId = '';
        this.payAccountName = '';
      }
      this.selectAccountType = nowType;
    },
    /**提交订单*/
    enterpriseOk(){
      this.selectEnterpriseShow = false;
      this.jumpEnterprise = true;
      this.onCreateOrder();
    },
    enterpriseClose(){
      this.selectEnterpriseShow = false;
      document.getElementById('enterpriseBalance').scrollIntoView({ block: "start", behavior: "smooth" });

    },
    noChoosePayClick(){
      this.noChoosePayShow = false;
    },
    submitReload() {
      this.submitStockNullFlag = false;
      window.location.reload();
    },
    sendGio(modluename, elementname, otherParam = {}) {
      const params = {
        df_channle: unionFlag() ? "百福德" : "官网",
        df_pagename: "提交订单",
        df_modulename: modluename,
        df_elementname: elementname,
        ...otherParam,
      };
      gioClickHandle("DF_elementClick", params, "channelGio");
    },
    initData() {
      // this.buyGoodsList = []; //切换地址赋初值
      // debugger;
      this.handleAddress();
      if (window.df_sdk_common.isBfd()) {
        addressApiV2.getUnionCityListV2({ union: this.unionFlag }).then((data) => {
          if (data.records.length) {
            this.checkAddressList = data.records;
          }
        });
      }
    },
    // 获取移动端二维码
    getQrCode() {
      if (this.couponInfo && this.couponInfo.coupon == "Y" && this.unionFlag) {
        var origin = "";
        // 环境
        if (API_ENV === "production") {
          // 生产环境
          origin = "corp.m.dongfangfuli.com";
        } else {
          origin = "corp.m." + API_ENV + ".dongfangfuli.com";
        }

        // let url = window.location.protocol + '//' + origin +'/tmall/order/confirm' + window.location.search + '&union=' + this.unionFlag;
        let url =
          window.location.protocol +
          "//" +
          origin +
          "/tmall/coupon/list?union=" +
          this.unionFlag;
        getQrcodeUrl({ url: url }).then((res) => {
          if (res) {
            this.qrcodeImg = window.URL.createObjectURL(res);
          }
        });
      }
    },
    // 根据条件判断是否要显示弹窗
    checkIsShowGoodsTip() {
      this.editdialog = !this.address.id;
      this.all_valided =
        this.notSaleGoodsList &&
        this.notSaleGoodsList.length > 0 &&
        (!this.buyGoodsList || this.buyGoodsList.length === 0);
      this.part_valided =
        this.notSaleGoodsList &&
        this.notSaleGoodsList.length > 0 &&
        this.buyGoodsList &&
        this.buyGoodsList.length > 0;
      this.invalideDialog = this.all_valided || this.part_valided;
      // console.log(editdialog)
      this.formatCreateOrderTips();
    },
    // 电子围栏运费提示
    electronicFenceFreight(info) {
      if ((info.oldTotalFreight || info.oldTotalFreight === 0) && info.oldTotalFreight != info.orderTotalFeight) {
        this.showFreightTips = true;
        setTimeout(() => {
          this.showFreightTips = false;
        }, 5000);
        document.getElementById('totalFreight').scrollIntoView({ block: "start", behavior: "smooth" });
      }
    },
    // 判断配件是否库存不足
    checkPartsStock() {
      if (this.annexItemStock == "Y") {
        this.showPartsNoStockFlag = true;
      }
    },
    // 判断是否选择了配件
    checkChooseFlag() {
      let flag = false;
      this.buyGoodsList &&
        this.buyGoodsList.length > 0 &&
        this.buyGoodsList.forEach((ele) => {
          ele.warehouseList &&
            ele.warehouseList.length > 0 &&
            ele.warehouseList.forEach((elem) => {
              if (elem.annexTotalNum > 0) {
                flag = true;
                return flag;
              }
            });
        });
      return flag;
    },
    // 展示配件售后提示
    showPartAftersaleTip() {
      if (this.checkChooseFlag()) {
        this.showPartsTipFlag = true;
      } else {
        this.createOrderAction();
      }
    },
    getAddressList(defaultId) {
      addressApiV2.getUserAddressListV2().then((data) => {
        const records = data.records;
        if (records.length) {
          records.map((item, index) => {
            if (item.addressId === defaultId) {
              records.unshift(records.splice(index, 1)[0]);
            }
          });
          this.$set(this, "addressList", records);
        }
        this.checkDefaultAddress(records);
        this.confirmOrder();
      });
    },
    // 验证是否要弹出地址添加窗口
    checkDefaultAddress(res) {
      this.isShowCancel = true;
      this.isCallBackReload = false;
      // this.address.id 判断是否是长地址
      if (!this.address.addressId) {
        // 用户地址库没有数据弹出地址添加窗口
        if (res.length <= 0) {
          this.isShowCancel = false;
          this.editAddressDialog = !this.editAddressDialog;
          this.addressDialog.addressItem = this.editAddressItem;
          return;
        }
        // 不是长地址匹配用户地址库中是否有匹配项
        let list = res.filter(
          (t) =>
            t.provinceName === this.address.provinceName &&
            t.cityName === this.address.cityName &&
            t.regionName === this.address.regionName &&
            t.streetName === this.address.streetName,
        );
        if (list.length <= 0) {
          list = res.filter(
            (t) =>
              t.provinceName === this.address.provinceName &&
              t.cityName === this.address.cityName &&
              t.regionName === this.address.regionName,
          );
        }
        if (list.length <= 0) {
          list = res.filter(
            (t) =>
              t.provinceName === this.address.provinceName &&
              t.cityName === this.address.cityName,
          );
        }
        if (list.length <= 0) {
          list = res.filter(
            (t) => t.provinceName === this.address.provinceName,
          );
        }
        let userAddress = null;
        if (list.length > 0) {
          // 如果有多条匹配地址,如果只有一条直接取值
          if (list.length > 1) {
            // 获取所有默认地址,如果没有默认地址取第一条
            let das = list.filter((t) => t.defaultAddress === 1);
            if (das.length > 0) {
              userAddress = das[0];
            } else {
              userAddress = list[0];
            }
          } else {
            userAddress = list[0];
          }
        } else {
          // 短地址匹配不到长地址给默认地址,弹出添加窗口
          if (this.isFirstLoad) {
            this.isShowCancel = true;
            this.isFirstLoad = false;
            this.isCallBackReload = true;
            userAddress = null;
          } else {
            // 没有默认地址取top1
            const das = res.filter((t) => t.defaultAddress === 1);
            if (das.length > 0) {
              userAddress = das[0];
            } else {
              userAddress = res[0];
            }
          }
        }
        if (userAddress) {
          this.addressId = userAddress.addressId || userAddress.id;
          const host = "." + window.location.hostname;
          Cookies.remove("address");
          Cookies.remove('address', { domain: '.dongfangfuli.com' });
          Cookies.remove("address", { domain: host });
          Cookies.set("address", userAddress, { expires: 365 });
          this.initData();
        } else {
          this.editAddressDialog = !this.editAddressDialog;
          this.addressDialog.addressItem = this.editAddressItem;
        }
      }
    },
    onEdit(address) {
      this.editAddressDialog = true;
      this.addressDialog = {
        dialogState: false,
        title: this.TLang("编辑收货地址", "orderConfirm"),
        enTitle: this.TLang("编辑收货地址", "orderConfirm"),
        addressItem: address,
      };
    },
    onAdd() {
      if (this.addressList.length >= 50) return;
      this.addressDialog = {
        dialogState: true, // 编辑 false 添加 true
        title: this.TLang("新增收货地址", "orderConfirm"),
        enTitle: this.TLang("新增收货地址", "orderConfirm"),
        addressItem: null,
      };
      this.editAddressDialog = true;
    },
    onSetDefaultAddress(address) {
      addressApiV2.updateUserAddressV2({
        ...address,
        id: address.addressId,
        defaultAddress: 1,
        channel: unionFlag() ? 2 : 1,
      }).then(() => {
        this.getAddressList(this.addressId);
      });
    },
    handleAddress() {
      let addressFromCookie = Cookies.get("address");
      if (!addressFromCookie)
        throw Error(this.TLang("errorAddressTips2", "orderConfirm"));
      if (addressFromCookie === "undefined" || addressFromCookie === "null") {
        throw Error(this.TLang("errorAddressTips", "orderConfirm"));
        Cookies.remove("address");
        this.$router.push("/");
      }
      this.address = JSON.parse(addressFromCookie);
      this.handleAddressLogic();
    },
    handleBuyGoodsList() {
      const buyGoodsList = getQueryString("buyGoodsList");
      if (!buyGoodsList)
        throw Error(this.TLang("errorAddressTips3", "orderConfirm"));
      this.goodsList = JSON.parse(buyGoodsList) || [];
    },
    // 编辑/新增 地址
    onConfirmEditAddressDialog(item) {
      if (this.addressList.length >= 50 && this.addressDialog.dialogState) {
        Toast.info(this.TLang("最多只能创建25条收货地址", "orderConfirm"));
        return;
      }
      this.addressDialog.dialogState
        ? this.addAddress({ id: item.addressId, ...item })
        : this.editAddress({ id: item.addressId, ...item });
    },
    onCancelEditAddressDialog() {
      if (this.isCallBackReload) {
        this.getAddressList(this.addressId);
      }
      this.addressDialog.dialogState = true;
      this.addressDialog.title = this.TLang("新建收货地址", "orderConfirm");
      this.addressDialog.addressItem = {};
      this.editAddressDialog = false;
    },
    /**
     * 无地址用户关闭新建地址弹框，点击取消返回上一页
     */
    onNewAddressCancel() {
      // console.log(document.referrer);
      // window.location.replace(document.referrer);
      window.history.go(-1);
    },
    /**
     * 短地址渲染
     */
    handleAddressLogic() {
      const { id, addressId } = this.address;
      if (!id && !addressId) {
        this.editAddressItem = this.address;
      } else {
        this.addressId = addressId || id;
      }
      this.handleBuyGoodsList();
      this.getAddressList(this.addressId);
    },
    // 电子围栏运费提示
    electronicFenceFreightShow() {
      this.showFreightTips = true;
      setTimeout(() => {
        this.showFreightTips = false;
      }, 5000);
    },
    confirmOrder(hideLoading) {
      const { goodsList, addressId, address } = this;
      let confirmOrderParameters = {}; // 确认订单参数
      if (!address || !goodsList.length) return;
      if (!addressId) {
        confirmOrderParameters = {
          buyGoodsList: goodsList,
          annexBuyGoodsList: this.annexBuyGoodsList,
          ...address,
          bookingId:getQueryString('bookingId')|| null,
        };
      } else {
        confirmOrderParameters = {
          buyGoodsList: goodsList,
          annexBuyGoodsList: this.annexBuyGoodsList,
          addressId,
          platform: 0,
          bookingId:getQueryString('bookingId')|| null,
        };
      }

      if (!hideLoading) {
        (this.loadding = true), Loading.show();
      } else {
        // this.choosePartsLoading = true;
        Loading.show(undefined, 0);
      }
      if (window.sessionStorage.getItem('oldTotalFreight')) {
        confirmOrderParameters.oldTotalFreight = JSON.parse(JSON.stringify(window.sessionStorage.getItem('oldTotalFreight')));
        window.sessionStorage.removeItem('oldTotalFreight');
      }
      /**来源为非权益前置*/
      confirmOrderParameters.pageSource = 'confirm';
      this.getConfirmOrder(confirmOrderParameters).then(() => {  Loading.hide(); }).catch(() => {
        Loading.hide();
      });
    },
    formatCreateOrderTips() {
      const orderType = getQueryString("orderType");
      const buyGoodsList = getQueryString("buyGoodsList") || [];
      const { goodsId, categoryId } = JSON.parse(buyGoodsList)[0] || {};
      if (this.all_valided) {
        if (Number(orderType) === 2) {
          this.confirmOrderTips = this.TLang(
            "orderGoodsInvalid",
            "orderConfirm",
          );
          this.backLink = `/shop/product/detail?cid=${categoryId}&gid=${goodsId}`;
          this.all_valideButton = this.TLang("返回详情页", "orderConfirm");
        } else if (Number(orderType) === 1) {
          this.confirmOrderTips = this.TLang(
            "orderGoodsInvalid",
            "orderConfirm",
          );
          this.backLink = "/shop/shopping/cart";
          this.all_valideButton = this.TLang("返回购物车", "orderConfirm");
        }
      }
      if (this.part_valided) {
        this.confirmOrderTips = this.TLang("goodsInvError", "orderConfirm");
      }
    },
    createOrderAction() {
      this.createOrderDisabled = true;
      if (this.hasHaitao) {
        this.$refs.haitaoInfo.$refs["haitaoForm"].validate((valid) => {
          v = valid;
        });
      }
      if (this.addressList.length === 0) {
        this.newAddressNotice = !this.newAddressNotice;
      }
      if (document.getElementById("userRemark") && !this.birthdayRemarkModal) {
        this.loadding = false;
        Loading.hide();
        this.createOrderDisabled = false;
        this.birthdayRemarkModal = true;
        this.userRemark =
          document.getElementById("userRemark").value ||
          this.TLang("生日快乐", "list");
        // console.log(document.getElementById("userRemark").value);
        return;
      }


      // 提交订单 异常判断
      /**
       *  GOODS_SOLDOUT(7,"商品已下架"),
       *   GOODS_STOCK_OOS(8,"商品库存不足"),
       */
      let obj = JSON.parse(JSON.stringify(this.createOrderParameter));
      // 企业账户
      if( this.selectAccountId && this.selectAccountType==='enterprise'){
        // 账户Id
        obj.accountId = this.selectAccountId;
        // 账户类型 0.企业账户 1.个人账户
        obj.accountType = 0;
        obj.accountName = this.interestsInfo.unionAccountName;
        obj.payAccountName = this.payAccountName;
      } else if (this.selectAccountType === 'personnal'){
        // 账户类型 0.企业账户 1.个人账户
        obj.accountType = 1;
        obj.accountName = this.interestsInfo.personalAccountName;

      }
      console.log('obj', obj);
      // return
      createOrder(obj).then((res) => {
        this.createOrderDisabled = false;
        if (res && res.code && res.code === 7) {
          this.confirmOrderTips = this.TLang("goodsXiaJia", "orderConfirm");
          this.invalideDialog = true;
          this.isReload = true;
          return;
        }
        if (res && res.code && res.code === 8) {
          this.confirmOrderTips = this.TLang("addressError", "orderConfirm");
          this.invalideDialog = true;
          this.isReload = true;
          return;
        }
        // 库存不足
        if (res && res.code && res.code === 101014) {
          //
          this.submitStockNullFlag = true;
          return;
        }
        if (res && res.code && res.msg) {
          Toast.info(res.msg);
          return;
        }
        // 判断是否需要审核订单 审核标记：0不用审核，1需要审核
        if (res && res.body) {
          window.sessionStorage.removeItem("birthdayInfoList");
          if (res.body.auditFlag === 1) {
            const unionstr = unionFlag() ? "&union=" + unionFlag() : "";
            const url =
              "/shop/order/payPending?orderNo=" +
              res.body.orderNo +
              "&auditTimeoutAt=" +
              res.body.auditTimeoutAt +
              unionstr;
            window.df_sdk_common.location.replace(url);
          } else {
            window.df_sdk_common.location.href = res.body;
          }
        }
        // 指定日期配送，超过截单时间会提示错误信息，让用户刷新页面，但是res捕捉不到该信息，统一被公共方法弹出了
        // 因此，利用页面弹出的错误信息，来决定错误提示后是否刷新
        if (!res) {
          let info = document.getElementsByClassName(
            "toast-container_simple",
          )[0].innerText;
          if (info && info.indexOf("发货日期") > -1) {
            setTimeout(() => {
              this.initData();
            }, 1000);
          }
        }
      });
    },
    closeDialog() {
      this.invalideDialog = false;
      if (this.isReload) {
        window.location.reload();
      }
    },
    mpClose() {
      this.visitRefundFlag = false;
    },
    mpOk() {
      this.visitRefundFlag = false;
      this.createOrderAction();
      // this.showPartAftersaleTip();
    },
    onCreateOrder() {
      const { addressId } = this.createOrderParameter;
      let isCreateOrder = true;
      let errorMsg = "";
      if(this.settleAccountInfo.isAllowed===0){
        return;
      }
      if (this.all_valided) return;
      if (!addressId) {
        this.$message.error(this.TLang("请选择用户的配送地址", "orderConfirm"));
        return;
      }
      if (
        this.epidemicDeliverInfo.allowDelivery === 0 &&
        this.epidemicDeliverInfo.mandatoryType === 0
      )
        return;
      if (this.createOrderParameter && this.createOrderParameter.buyInfoList) {
        for (let i=0;i<this.createOrderParameter.buyInfoList.length;i++){
          const item = this.createOrderParameter.buyInfoList[i];
          if (item.deliveryWay === '3' && !item.expectDeliveryTime) {
            errorMsg = this.TLang('请选择发货时间', 'orderConfirm');
            isCreateOrder = false;
            break;
          } else if(item.deliveryWay === '1' && (!item.expectDeliveryTime || !item.expectPreciseTime)){
            document.getElementById('deliveryWay_' + item.warehouseId).scrollIntoView({block: 'center'});
            errorMsg = this.TLang('请选择期望送达时间', 'orderConfirm');
            isCreateOrder = false;
            break;
          }
        }
      }

      if (!isCreateOrder) {
        this.$message.error(errorMsg);
        return;
      }
      if (!this.selectAccountType && this.confrimOrderInfo && this.confrimOrderInfo.queryEnterPrise) {
        this.noChoosePayShow = true;
        return;
      }
      /** 企业账户判断 没有选择账户余额 弹窗提示*/
      if (this.confrimOrderInfo && this.confrimOrderInfo.queryEnterPrise && !this.jumpEnterprise && this.selectAccountType==='enterprise'){
        if (!this.selectAccountId){
          this.noChoosePayShow = true;
          return;
        }
      }
      // TODO: 防疫包定制礼包套餐在提交订单，新增提示
      if (this.settleAccountInfo.refundFlag) {
        this.visitRefundFlag = true;
      } else {
        this.createOrderAction();
        // this.showPartAftersaleTip();
      }
      // this.createOrderAction();
    },
    showFreightRule() {
      this.showFreightRuleFlag = true;
    },
    handleClose() {
      this.showFreightRuleFlag = false;
    },
    openCouponTip() {
      const gioParams = {
        df_pagename: "提交订单",
        df_modulename: "优惠券信息",
        df_elementname: "优惠券引导",
      };
      //点击优惠券提示
      gioClickHandle("DF_elementClick", gioParams);

      this.showCouponDialog = true;
    },
    // 修改收费配件数量 1、加比较复杂！！ 2、减为0的时候其次！
    modifyPartsNum(info, num, type, warehouseItem) {
      // console.log('info, num',info, num, type, warehouseItem);
      switch (type) {
      case "add": // 配件数量加
        // 若入参annexBuyGoodsList列表中已包含该配件，直接更改其数量
        if (this.checkPartsIn(info, warehouseItem)) {
          this.annexBuyGoodsList.forEach((a) => {
            a.warehouseDtoList &&
                a.warehouseDtoList.length > 0 &&
                a.warehouseDtoList.forEach((b) => {
                  b.annexBuyGoodsList &&
                    b.annexBuyGoodsList.length > 0 &&
                    b.annexBuyGoodsList.forEach((c) => {
                      if (
                        c.goodsId == info.goodsId &&
                        c.categoryId == info.categoryId &&
                        a.merchantNo == warehouseItem.merchantNo &&
                        b.warehouseId == warehouseItem.warehouseId
                      ) {
                        c.num = num;
                      }
                    });
                });
          });
        } else if (
          this.checkMerchantIn(warehouseItem) &&
            this.checkWarehouseIn(warehouseItem)
        ) {
          // 入参annexBuyGoodsList列表中，含有同商家同仓库配件，则在同仓库下添加该配件
          this.annexBuyGoodsList.forEach((a) => {
            if (a.merchantNo == warehouseItem.merchantNo) {
              a.warehouseDtoList &&
                  a.warehouseDtoList.length > 0 &&
                  a.warehouseDtoList.forEach((b) => {
                    if (b.warehouseId == warehouseItem.warehouseId) {
                      b.annexBuyGoodsList.push({
                        categoryId: info.categoryId,
                        goodsId: info.goodsId,
                        num: num,
                      });
                    }
                  });
            }
          });
        } else if (
          this.checkMerchantIn(warehouseItem) &&
            !this.checkWarehouseIn(warehouseItem)
        ) {
          // 入参annexBuyGoodsList列表中，含有同商家但无同仓库，则在该商家下，添加该配件所在仓库及配件本身信息
          this.annexBuyGoodsList.forEach((a) => {
            if (a.merchantNo == warehouseItem.merchantNo) {
              a.warehouseDtoList.push({
                annexBuyGoodsList: [
                  {
                    categoryId: info.categoryId,
                    goodsId: info.goodsId,
                    num: num,
                  }
                ],
                preSell: warehouseItem.preSell,
                warehouseNo: warehouseItem.warehouseNo,
                warehouseId: warehouseItem.warehouseId,
              });
            }
          });
        } else {
          this.annexBuyGoodsList.push({
            merchantNo: warehouseItem.merchantNo,
            warehouseDtoList: [
              {
                annexBuyGoodsList: [
                  {
                    categoryId: info.categoryId,
                    goodsId: info.goodsId,
                    num: num,
                  }
                ],
                preSell: warehouseItem.preSell,
                warehouseNo: warehouseItem.warehouseNo,
                warehouseId: warehouseItem.warehouseId,
              }
            ],
          });
        }
        // this.initData();
        this.confirmOrder(true);
        break;
      case "minus":
        // 配件数量减
        if (num == 0) {
          this.annexBuyGoodsList.forEach((a, aIndex) => {
            a.warehouseDtoList &&
                a.warehouseDtoList.length > 0 &&
                a.warehouseDtoList.forEach((b, bIndex) => {
                  b.annexBuyGoodsList &&
                    b.annexBuyGoodsList.length > 0 &&
                    b.annexBuyGoodsList.forEach((c, cIndex) => {
                      if (
                        c.goodsId == info.goodsId &&
                        c.categoryId == info.categoryId &&
                        a.merchantNo == warehouseItem.merchantNo &&
                        b.warehouseId == warehouseItem.warehouseId
                      ) {
                        // 若该仓库下有多个配件数据，则直接去除该商品数据;
                        if (b.annexBuyGoodsList.length > 1) {
                          b.annexBuyGoodsList.splice(cIndex, 1);
                        } else if (a.warehouseDtoList.length > 1) {
                          // 若该商家下有多个仓库，但该仓库下只有一条数据，则删掉该仓库数据
                          a.warehouseDtoList.splice(bIndex, 1);
                        } else {
                          // 若该商家下只有一个配件，则直接删除该商家数据
                          this.annexBuyGoodsList.splice(aIndex, 1);
                        }
                        // this.initData();
                        this.confirmOrder(true);
                        return;
                      }
                    });
                });
          });
        } else {
          this.annexBuyGoodsList.forEach((a) => {
            a.warehouseDtoList &&
                a.warehouseDtoList.length > 0 &&
                a.warehouseDtoList.forEach((b) => {
                  b.annexBuyGoodsList &&
                    b.annexBuyGoodsList.length > 0 &&
                    b.annexBuyGoodsList.forEach((c) => {
                      if (
                        c.goodsId == info.goodsId &&
                        c.categoryId == info.categoryId &&
                        a.merchantNo == warehouseItem.merchantNo &&
                        b.warehouseId == warehouseItem.warehouseId
                      ) {
                        c.num = num;
                      }
                    });
                });
          });
          // this.initData();
          this.confirmOrder(true);
        }
        break;
      case "input":
        if (num == 0) {
          this.annexBuyGoodsList.forEach((a, aIndex) => {
            a.warehouseDtoList &&
                a.warehouseDtoList.length > 0 &&
                a.warehouseDtoList.forEach((b, bIndex) => {
                  b.annexBuyGoodsList &&
                    b.annexBuyGoodsList.length > 0 &&
                    b.annexBuyGoodsList.forEach((c, cIndex) => {
                      if (
                        c.goodsId == info.goodsId &&
                        c.categoryId == info.categoryId &&
                        a.merchantNo == warehouseItem.merchantNo &&
                        b.warehouseId == warehouseItem.warehouseId
                      ) {
                        // 若该仓库下有多个配件数据，则直接去除该商品数据;
                        if (b.annexBuyGoodsList.length > 1) {
                          b.annexBuyGoodsList.splice(cIndex, 1);
                        } else if (a.warehouseDtoList.length > 1) {
                          // 若该商家下有多个仓库，但该仓库下只有一条数据，则删掉该仓库数据
                          a.warehouseDtoList.splice(bIndex, 1);
                        } else {
                          // 若该商家下只有一个配件，则直接删除该商家数据
                          this.annexBuyGoodsList.splice(aIndex, 1);
                        }
                        // this.initData();
                        this.confirmOrder(true);
                        return;
                      }
                    });
                });
          });
        } else {
          this.annexBuyGoodsList.forEach((a) => {
            a.warehouseDtoList &&
                a.warehouseDtoList.length > 0 &&
                a.warehouseDtoList.forEach((b) => {
                  b.annexBuyGoodsList &&
                    b.annexBuyGoodsList.length > 0 &&
                    b.annexBuyGoodsList.forEach((c) => {
                      if (
                        c.goodsId == info.goodsId &&
                        c.categoryId == info.categoryId &&
                        a.merchantNo == warehouseItem.merchantNo &&
                        b.warehouseId == warehouseItem.warehouseId
                      ) {
                        c.num = num;
                      }
                    });
                });
          });
          // this.initData();
          this.confirmOrder(true);
        }
        break;
      }
    },
    checkPartsIn(info, warehouseItem) {
      let flag = false;
      if (this.annexBuyGoodsList.length > 0) {
        this.annexBuyGoodsList.forEach((a) => {
          a.warehouseDtoList &&
            a.warehouseDtoList.length > 0 &&
            a.warehouseDtoList.forEach((b) => {
              b.annexBuyGoodsList &&
                b.annexBuyGoodsList.length > 0 &&
                b.annexBuyGoodsList.forEach((c) => {
                  if (
                    c.goodsId == info.goodsId &&
                    c.categoryId == info.categoryId &&
                    a.merchantNo == warehouseItem.merchantNo &&
                    b.warehouseId == warehouseItem.warehouseId
                  ) {
                    flag = true;
                    return flag;
                  }
                });
            });
        });
      }
      return flag;
    },
    // 判断是否含有同商家
    checkMerchantIn(warehouseItem) {
      let flag = false;
      if (this.annexBuyGoodsList.length > 0) {
        this.annexBuyGoodsList.forEach((a) => {
          if (a.merchantNo == warehouseItem.merchantNo) {
            flag = true;
            return flag;
          }
        });
      }
      return flag;
    },
    // 判断是否含有同仓库
    checkWarehouseIn(warehouseItem) {
      let flag = false;
      if (this.annexBuyGoodsList.length > 0) {
        this.annexBuyGoodsList.forEach((a) => {
          if (a.merchantNo == warehouseItem.merchantNo) {
            a.warehouseDtoList &&
              a.warehouseDtoList.length > 0 &&
              a.warehouseDtoList.forEach((b) => {
                if (b.warehouseId == warehouseItem.warehouseId) {
                  flag = true;
                  return flag;
                }
              });
          }
        });
      }
      return flag;
    },
  },
};
</script>

<style lang="less">
.confirm-wrap {
  .coupon-wrap {
    line-height: 32px;
    font-size: 12px;

    font-weight: 500;
    color: #333;
    padding-left: 22px;
    background: url("~@assets/images/icon_coupon.png") left center no-repeat;
    background-size: 17px 13px;
    .conponCode {
      color: #fc4524;
      cursor: pointer;
    }
  }
  .order-control {
    .settle-wrap {
      .card-theme;
      padding: 24px;

      .settle-wrap-item {
        text-align: right;
        span {
          display: inline-block;

          &:last-of-type {
            width: 11%;
          }
        }
      }
    }
  }
  .birthday-nuoxin-dialog {
    transform: translateY(-50%);
    .content {
      .nuoxin-footer {
        display: flex;
        justify-content: center;
        margin-top: 44px;
        .nuoxin-confirm,
        .nuoxin-close {
          width: 120px;
          height: 40px;
          border-radius: 4px;
          text-align: center;
          line-height: 40px;
          font-size: 14px;
        }
        .nuoxin-confirm {
          background: linear-gradient(
            315deg,
            rgba(92, 180, 236, 1) 0%,
            rgba(61, 150, 226, 1) 100%
          );

          font-weight: bold;
          color: rgba(255, 255, 255, 1);
        }
        .nuoxin-close {
          border: 1px solid rgba(229, 229, 229, 1);

          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          margin-left: 20px;
        }
      }
      p {
        font-size: 14px;

        color: rgba(153, 153, 153, 1);
        .userremark {
          color: #111;
          word-break: break-all;
        }
      }
    }
  }
  .order-invalide-dialog,
  .couponDialog {
    transform: translateY(-50%);
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      text-align: center;
      .title {
        font-size: 18px;
        color: #333;
        font-weight: 400;
      }
      .desc {
        margin-top: 14px;
      }
      .part_valided {
        font-size: 18px;
        padding: 0 50px;
      }
      .part_valided_enterprise {
        font-size: 18px;
        color: #333;
        font-weight: 400;;
        padding: 0 60px;
      }
      .mpTip {
        font-size: 16px;

        font-weight: 500;
        color: #333333;
        line-height: 22px;
        margin: 0 0 10px;
      }
      .mpDesc {
        font-size: 16px;

        font-weight: 400;
        color: #666666;
        line-height: 22px;
        text-align: justify;
        padding: 0 24px;
      }
      .btns {
        height: 40px;
        line-height: 40px;
        text-align: center;
        border-radius: 4px;
        font-size: 14px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        cursor: pointer;
        color: #fff;
        background: linear-gradient(315deg, #5cb4ec, #3d96e2);
        width: 88px;
        margin-top: 20px;
        display: inline-block;
      }
      .enterpriseClose{
        margin-top: 15px;
        width: 100px;
        height: 40px;
        margin-right: 30px;
        border: 1px solid #e5e5e5;
        background: none;
        color: #666666;
      }
      .enterpriseOk{
        width: 100px;
        height: 40px;
      }
      .mar-40{
        margin-top: 40px;
      }
      .no-choose-pay-tip{
        color: #333;
        font-weight: 400;
        font-size: 18px;


      }

      .mpOk {
        width: 120px;
        height: 39px;
        margin-right: 20px;
      }
      .mpClose {
        width: 120px;
        height: 40px;
        border-radius: 4px;
        border: 1px solid #e5e5e5;
        background: none;
        color: #666666;
      }
      .back {
        margin-left: 20px;
        border: 1px solid #3d96e2;
        background: #fff;
        color: #3d96e2;
      }
      .close {
        // border: 1px solid #3d96e2;
        // background: #fff;
        // color: #3d96e2;
      }
      .el-form-item {
        margin-bottom: 20px;
      }
    }
  }
  .order-disable {
    background: #ccc;
  }
  .couponDialog {
    .el-dialog__body {
      padding: 0;
      .title {
        position: absolute;
        top: 26px;
        left: 28px;
        font-size: 20px;

        font-weight: bold;
        color: #333333;
      }
      .subTitle {
        position: absolute;
        top: 64px;
        left: 28px;
        text-align: left;
        font-size: 16px;

        color: #666666;
      }
      .steps {
        width: 100%;
        text-align: left;
        position: absolute;
        top: 193px;
        left: 0;
        font-size: 14px;

        font-weight: 400;
        color: #333333;
        span {
          display: inline-block;
          text-align: center;
        }
      }
      .stepOne {
        width: 163px;
        position: absolute;
        top: 236px;
        left: 36px;
        text-align: left;
        img {
          width: 100%;
          display: block;
        }
        li {
          font-size: 14px;

          color: #666;
          line-height: 20px;
          margin-bottom: 20px;
        }
      }
      .stepTwo {
        width: 150px;
        position: absolute;
        top: 236px;
        left: 275px;
      }
      .stepThree {
        width: 163px;
        position: absolute;
        top: 236px;
        right: 56px;
      }
    }
  }
}

.el-tooltip__popper {
  background: #fff !important;
  box-shadow: 0px 4px 11px 0px rgba(81, 86, 95, 0.3);
  .popper__arrow {
    left: 51% !important;
  }
  .feight-weight-info {
    min-width: 240px;
    padding: 20px;
    color: rgb(81, 86, 95);
  }
  .showFreightRule {
    display: inline-block;
    font-size: 12px;

    font-weight: 400;
    color: #3d96e2;
    line-height: 17px;
    padding-right: 14px;
    background: url("../../../assets/images/order/freightRuleMoren.png") right
      center no-repeat;
    background-size: 12px auto;
    cursor: pointer;
    padding-left: 20px;
    margin-bottom: 10px;
  }
}
.freightDialog {
  width: 420px;
}
.freightDialog .el-dialog__title {
  font-size: 18px;

  color: #333;
  line-height: 24px;
}
.freightDialog .el-dialog__body {
  border-top: none;
  padding: 7px 40px 20px;
  font-size: 14px;

  color: #666;
  line-height: 26px;
}
.partsDialog {
  width: 420px;
}

.partsDialog .el-dialog__body {
  border-top: none;
  padding: 24px 16px;
  font-size: 14px;

  color: #333;
  line-height: 20px;
  text-align: center;
}
.partsDialog .partsKnowBtn {
  display: inline-block;
  padding: 16px 51px 15px;
  margin: 0 auto;
  background: linear-gradient(315deg, #5cb4ec 0%, #3d96e2 100%);
  border-radius: 4px;
  font-size: 16px;

  color: #fff;
  line-height: 21px;
  margin-top: 40px;
}
.order-freight {
  position: relative;
  .tips {
    position: absolute;
    right: 0;
    top: -40px;
    width: auto;
    max-width: 250px;
    font-size: 12px;
    // font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 17px;
    padding: 9px 10px;
    background: rgba(0,0,0,0.7);
    z-index: 9;
    white-space: pre-wrap;
    box-shadow: 0px 2px 8px 0px rgba(53, 59, 64, 0.15);
    border-radius: 4px;
    box-sizing: content-box;
    &::after {
      content: '';
      display: inline-block;
      position: absolute;
      bottom: -14px;
      right: 10px;
      border: 7px solid;
      border-color: rgba(0,0,0,0.7) transparent transparent;
    }
  }
}
.settle-wrap-account{
  text-align: right;
  color: #ff6600;
}
.enterprise-balance-part{
  border-left: 1px solid #e5e5e5;
  border-right: 1px solid #e5e5e5;
  margin-bottom: -12px;
}
.line-service {
  display: flex;
  color:#666;
  font-size: 14px;
  img {
    width: 16px;
    height: 16px;
  }
}
.enterprse-person-all{
  padding: 24px;
  .enterprise-title{
    font-size: 20px;
    font-weight: bold;
    color: #111111;
    margin-bottom: 16px;
  }
  .enterprise-personnal-item-wrapper{
    margin-right: 20px;
    padding: 20px 15px;
    width: auto;
    display: flex;
    align-items: center;
    border: 1px solid #E5E5E5;
    .enterprise-icon{
      width: 18px;
      height: 18px;
      margin-right: 10px;
    }
    .enterprise-personnal-item-title{
      font-size: 16px;
      font-weight: 400;
      color: #333333;
    }
    .enterprise-personnal-item-subTitle{
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      .blue-style{
        color: #3FA6FF;
      }
      .orange-style{
        color: #FF6600;
      }

    }

  }
  .enterprse-person-wrapper{
    display: flex
  }
  .enterprise-personnal-item-wrapper-active{
    border: 2px solid #3D96E2;
  }

}
</style>
